module.exports = __webpack_public_path__ + "static/media/ausnahme_map.2bdc21b5.jpg";